<!-- <a id="dashboard-signature-section" [routerLink]="SIGN_IN_NAME" title="'Firma'" class="dashboard-card section-card" [ngClass]="{'disabled': status < minStatus.signature}">
    <div class="dashboard-card__header">
        <h3 class="h-title">{{ 'signature_section_title' | translate }}</h3>
    </div>
    <div class="dashboard-card__body">
        <span class="ic ic-edit"></span>
        <h4 class="card-text"> {{ 'signature_section_msg' | translate }} </h4>
    </div>
    <div class="dashboard-card__footer">
    </div>
</a> -->

<a
  id="dashboard-signature-section"
  [routerLink]="SIGN_IN_NAME"
  title="'Firma'"
  class="dashboard-card section-card"
  [ngClass]="{ disabled: status < minStatus.signature || isRejected }"
>
  <div class="dashboard-card__header">
    <h3 class="h-title">{{ 'signature_section_title' | translate }}</h3>
  </div>
  <div class="dashboard-card__body">
    <span class="ic ic-edit"></span>
    @if (!httpError) {
      <div>
        @if (!showInfo) {
          <h4 class="card-title">{{ 'signature_section_msg' | translate }}</h4>
        }

        @if (status >= minStatus.signature && signatureState?.notaryName) {
          <h4 class="card-title">
            {{ signatureState?.notaryName }}
          </h4>
        }

        @if (status >= minStatus.signature && address) {
          <p class="card-text">{{ address }}</p>
        }

        @if (status >= minStatus.signature && signatureState?.signatureDate && signatureState?.signatureTime) {
          <h4 class="pd-b-10">
            {{ signatureState?.signatureDate | date: "d 'de' MMMM y" }} -
            {{ signatureState?.signatureTime.substr(0, 5) }} h
          </h4>
        }

        @if (status == minStatus.signature) {
          <div class="btn btn-02">{{ 'btn_continue_here' | translate }}</div>
        }
      </div>
    } @else {
      <p class="has-error">{{ 'appraisal_section_msg_error' | translate }}</p>
    }
  </div>

  <div class="dashboard-card__footer"></div>
</a>
